export const getCategoryTerritory = (parameter, cat1, cat2, cat3, cat4) => {
  if (parameter === 0) {
    return cat1;
  }
  if (parameter <= 2) {
    return cat2;
  }
  if (parameter <= 4) {
    return cat3;
  }
  return cat4;
};

export const getFeatureStyle = (feature) => {
  const defaultStyles = {
    MultiPolygon: {
      fillColor: 'rgba(54, 73, 97, 0.1)',
      color: 'rgba(54, 73, 97, 0.50)',
      opacity: 0.7,
      fillOpacity: 0.7,
      weight: 2,
    },
    Polygon: {
      color: 'rgba(7, 130, 124, 1)',
      opacity: 1,
      fillOpacity: 0.4,
      weight: 2,
    },
    default: {
      color: '#000000',
      weight: 1,
    },
  };

  const type = feature.geometry?.type || 'default';
  const style = { ...defaultStyles[type] };

  if (type === 'Polygon') {
    const ahs = feature.properties?.jumlah_ahs || 0;
    style.fillColor = getFillColorByHousehold(ahs);
    style.color = getFillColorByHousehold(ahs);
  }

  return {
    ...style,
    ...(feature.properties?.style || {}),
  };
};
export const getFillColorByHousehold = (ahs) =>
  getCategoryTerritory(ahs, '#46FF2A', '#FDFF06', '#FF9900', '#FF1000');

export const getBorderColorByHousehold = (ahs) =>
  getCategoryTerritory(ahs, '#429892', '#AE8300', '#8F5907', '#B21308');

export const getFeatureProperties = (feature, type) => {
  const props = feature.properties || {};
  if (type === 'POI') {
    return {
      name: props.Customer_Name || 'N/A',
      latitude: feature.geometry.coordinates?.[1] || 0,
      longitude: feature.geometry.coordinates?.[0] || 0,
      id_outlet: props.Customer_Id || 'N/A',
      cluster_ahs: props.bill_nickname || 'N/A',
      depo: props.depo_name || 'N/A',
      telpon: props.telpon || 'N/A',
      address: props.Address || 'N/A',
      village: props.Kelurahan || 'N/A',
      district: props.Kecamatan || 'N/A',
      city: props.Kota || 'N/A',
      distributor: props.Distributor || 'N/A',
      category: props.category || 'N/A',
    };
  } else if (type === 'Territory' || type === 'SES') {
    const pointStr = props.centroid;
    const coords = pointStr?.match(/-?\d+(\.\d+)?/g);
    const longlat = `${coords[1]}, ${coords[0]}`;
    return {
      name: 'Catchment Info',
      total_household: props.total_household ?? 'N/A',
      coverage: props.luas_km
        ? new Intl.NumberFormat('id-ID').format(props.luas_km * 1000) + ' m²'
        : 'N/A',
      nama_desa: props.nama_desa || 'N/A',
      center: longlat,
      total_ahs: props?.jumlah_ahs ?? 'N/A',
      class: props?.class ?? 'N/A',
      ses_ab: props?.ses_distribution?.['SES-AB'] ?? 'N/A',
      ses_bc: props?.ses_distribution?.['SES-BC'] ?? 'N/A',
      ses_cd: props?.ses_distribution?.['SES-CD'] ?? 'N/A',
      cluster_id: props.cluster_id ?? 'N/A',
      village_code: props?.village_codes ?? [],
    };
  } else if (type === 'Area') {
    const [key, value] =
      Object.entries(props).find(([key]) => key.includes('nama')) || [];
    let area;
    if (key.includes('provinsi')) {
      area = 'Province';
    } else if (key.includes('kota')) {
      area = 'City';
    } else if (key.includes('kecamatan')) {
      area = 'District';
    } else if (key.includes('desa')) {
      area = 'Village';
    }
    return {
      name: 'Area Info',
      area: { key: area, value },
      coverage: props.luas
        ? new Intl.NumberFormat('id-ID').format(props.luas) + ' m²'
        : 'N/A',
    };
  }
  return null;
};
